import { useStyles } from './UebersichtStyles';
import { useMsal } from '@azure/msal-react';
import { globalStyles } from '../../assets/globalStyles';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import React, { ReactElement, useEffect } from 'react';
import { Error, Cancel, CheckCircle, AssignmentTurnedIn } from '@material-ui/icons';
import ForumIcon from '@material-ui/icons/Forum';
import {
  CircularProgress,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Accordion,
  AccordionSummary,
  Tooltip,
  Button,
  Badge
} from '@material-ui/core';
import { selectLoadingDatenvollsteandigkeit, selectMaxKommunication, selectMaxDatenvollsteandigkeit, getBetriebsstatus, selectNumberOfDevicesKommunikation, selectNumberOfDevicesDatenvollstaendigkeit, setSort } from '../betriebsereignisse/betriebsereignisseSlice';
import { getPQStatus, selectPQStatus, selectPQStatusLoading } from '../pqereignisse/pqEreignisseSlice';
import { getNetzereignisseWithKonfig, selectNetzsereignisseListe, selectNetzereignisLoading } from '../administration/netzereignisse/netzereignisseSlice';
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { toUTCDateString } from '../../utils/utils';
import { getMessstellenForLookup, getMessstellenLookup, selectMessstellenLookup, selectMessstellenDictionary } from '../../features/messstellenLookup/messstellenLookupSlice';
import LegendeStoerung from '../../features/legende/legendeStoerung';
import CachedIcon from '@material-ui/icons/Cached';
import { useHistory } from 'react-router';
import { sortOrder, sortProp } from '../betriebsereignisse/betriebsereignisseTypes';



export default function Uebersicht(): ReactElement {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const [reload, setReload] = React.useState(false);

  useEffect(() => {
    dispatch(getPQStatus());
    dispatch(getNetzereignisseWithKonfig());
    dispatch(getMessstellenForLookup());
    dispatch(getBetriebsstatus());
  }, [instance, reload]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const history = useHistory();

  const getIconForStateValuePQ = (value: number) => {
    switch (value) {
      case 0:
        return (
          <Tooltip title="Keine Störung" >
            <CheckCircle style={{ color: "green" }} />
          </Tooltip>)
      case 1:
        return (
          <Tooltip title="Störung bei geplanten Ereignissen" >
            <Error style={{ color: "green" }} />
          </Tooltip>)
      case 2:
        return (
          <Tooltip title="Punktereignis (kürzer 1 Sekunde" >
            <Error style={{ color: "orange" }} />
          </Tooltip>)
      case 3:
        return (
          <Tooltip title="Abschnittsereignis (länger 1 Sekunde)" >
            <Error className={classes.redSignalColor} />
          </Tooltip>)
      default: return "";
    }
  };

  const getIconForStateValueGeraet = (value: number) => {
    switch (value) {
      case 0:
        return (
          <Tooltip title="Keine Störung" >
            <CheckCircle style={{ color: "green" }} />
          </Tooltip>)
      case 1:
        return (
          <Tooltip title="Störung bei geplanten Ereignissen" >
            <Error style={{ color: "green" }} />
          </Tooltip>)
      case 2:
        return (
          <Tooltip title="Störung" >
            <Cancel className={classes.redSignalColor} />
          </Tooltip>)
      default: return "";
    }
  };

  const loadingDatenvollsteandigkeit = useAppSelector(selectLoadingDatenvollsteandigkeit);

  const pqStatus = useAppSelector(selectPQStatus);
  const pqStatusLoading = useAppSelector(selectPQStatusLoading);
  const netzereignisLoading = useAppSelector(selectNetzereignisLoading);
  const netzereignisseListe = useAppSelector(selectNetzsereignisseListe);

  const messstellenDict = useAppSelector(selectMessstellenDictionary);
  const messstellenLoadingLookup = useAppSelector(selectMessstellenLookup);

  const generalKommunicationStatus = useAppSelector(selectMaxKommunication);
  const numberOfDevicesKommunikation = useAppSelector(selectNumberOfDevicesKommunikation);
  const generalDatenvollsteandigkeit = useAppSelector(selectMaxDatenvollsteandigkeit);
  const numberOfDevicesDatenvollstaendigkeit = useAppSelector(selectNumberOfDevicesDatenvollstaendigkeit);

  const isUTC = useAppSelector(selectDate);

  return (
    <Container maxWidth={false} style={{ marginTop: "10px" }}>
      <Grid item container md={12}>
        <Grid item md={11} >
          <Typography color="primary" variant="h5">
            Übersicht
          </Typography>
          </Grid>
          <Grid item md={12} >
            <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "16px" }}>
              <Button color="secondary" 
              onClick={() => setReload(!reload)}>Neu Laden<CachedIcon style={{marginLeft: "10px"}}/></Button >
            </Grid> 
          </Grid>
        <Grid item md={12} >
          <LegendeStoerung name={"overview"} />
        </Grid>
      </Grid>
      <Grid container md={12} spacing={2} >
        <Grid item container md={6} spacing={2} >
          <Grid item md={12}>
            <Paper>
              <Grid item container md={12}>
                <Accordion style={{ width: "100%", marginBottom: "-3px" }}>
                  <AccordionSummary>
                    <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Gerätestatus</Typography>
                  </AccordionSummary>
                </Accordion>
              </Grid>
              {loadingDatenvollsteandigkeit ?
                (
                  <TableContainer className={classes.heightScrolledTableBottom}>
                    <Table stickyHeader style={{ overflow: "hidden" }}>
                      <TableHead>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                      </TableHead>
                    </Table>
                  </TableContainer>
                )
                : (
                  <TableContainer>
                    <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                      <TableHead>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}></TableCell>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}></TableCell>
                        <TableCell align="center" className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "20%" }}>letzte 24 Stunden</TableCell>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "20%" }}></TableCell>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "20%" }}></TableCell>
                      </TableHead>
                      <TableBody>
                        <TableRow hover={true} onClick={() => {dispatch(setSort({sortProp: sortProp.datenvollstaendigkeit, sortOrder: sortOrder.errorFirst})); history.push("/geraeteverwaltung/betriebsereignisse")}} style={{cursor: "pointer"}}>
                          <TableCell style={{ maxWidth: "10px", width: "10px", paddingRight: "0px" }}><AssignmentTurnedIn color="primary" /></TableCell>
                          <TableCell>Datenvollständigkeit</TableCell>
                          <TableCell align="center"><Badge badgeContent={numberOfDevicesDatenvollstaendigkeit} color="primary" style={{zIndex: 99}}>{getIconForStateValueGeraet(generalDatenvollsteandigkeit)}</Badge></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                        <TableRow hover={true} onClick={() => {dispatch(setSort({sortProp: sortProp.kommunikation, sortOrder: sortOrder.errorFirst})); history.push("/geraeteverwaltung/betriebsereignisse")}} style={{cursor: "pointer"}}>
                          <TableCell style={{ maxWidth: "10px", width: "10px", paddingRight: "0px" }}><ForumIcon color="primary" /></TableCell>
                          <TableCell>Kommunikation</TableCell>
                          <TableCell align="center"><Badge badgeContent={numberOfDevicesKommunikation} color="primary">{getIconForStateValueGeraet(generalKommunicationStatus)}</Badge></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
            </Paper>
          </Grid>
          <Grid item md={12}>
            <Paper>
              <Grid item container md={12} >
                <Accordion style={{ width: "100%", marginBottom: "-3px" }}>
                  <AccordionSummary>
                    <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Status</Typography>
                  </AccordionSummary>
                </Accordion>
              </Grid>
              {pqStatusLoading ?
                (
                  <TableContainer className={classes.heightScrolledTableBottom}>
                    <Table stickyHeader style={{ overflow: "hidden" }}>
                      <TableHead>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                      </TableHead>
                    </Table>
                  </TableContainer>
                )
                : (
                  <TableContainer  >
                    <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                      <TableHead>
                        <TableCell style={{ backgroundColor: "white" }}></TableCell>
                        <TableCell align="center" className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "20%" }}>letzte 24 Stunden</TableCell>
                        <TableCell align="center" className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "20%" }}>letzte 30 Tage</TableCell>
                        <TableCell align="center" className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "20%" }}>letzte 12 Monate</TableCell>
                      </TableHead>
                      <TableBody>
                        {pqStatus.map((statusElement) => (
                          <TableRow key={statusElement.beschreibung} hover={true}>
                            <TableCell>{statusElement.beschreibung}</TableCell>
                            <TableCell align="center">{getIconForStateValuePQ(statusElement.status24h)}</TableCell>
                            <TableCell align="center">{getIconForStateValuePQ(statusElement.status1Month)}</TableCell>
                            <TableCell align="center">{getIconForStateValuePQ(statusElement.status12Month)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
            </Paper>
          </Grid>
        </Grid>
        <Grid item container md={6} spacing={2}>
          <Grid item md={12}>
            <Paper style={{ minWidth: "104%" }}>
              <Grid item container md={12} >
                <Accordion style={{ width: "100%", marginBottom: "-3px", }}>
                  <AccordionSummary>
                    <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Netzereignis</Typography>
                  </AccordionSummary>
                </Accordion>
              </Grid>
              {netzereignisLoading && messstellenLoadingLookup ?
                (
                  <TableContainer className={classes.heightScrolledTableBottom} >
                    <Table stickyHeader style={{ overflow: "hidden" }}>
                      <TableHead>
                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                      </TableHead>
                    </Table>
                  </TableContainer>
                )
                : (
                  <TableContainer component={Paper} style={{ minHeight: "925px" }}>
                    <Table
                      className={classes.table}
                      size="small"
                      aria-label="uw-table"
                      stickyHeader
                      style={{ marginBottom: "50px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }} >Startzeit</TableCell>
                          <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Endzeit</TableCell>
                          <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Ereignisüberschrift</TableCell>
                          <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Umspannwerk</TableCell>
                          <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Schaltfeld</TableCell>
                          <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Messstelle</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody >
                        {netzereignisseListe.map((row) => (
                          <TableRow key={row.id} hover={true} onClick={() => history.push("/netzereignisse/"+row.id)} style={{cursor: "pointer"}}>
                            <TableCell>{isUTC ? toUTCDateString(new Date(row.zeit)) : new Date(row.zeit).toLocaleString()}</TableCell>
                            <TableCell>{isUTC ? toUTCDateString(new Date(row.ende)) : new Date(row.ende).toLocaleString()}</TableCell>
                            <TableCell>{row.ereignisueberschrift}</TableCell>
                            <TableCell>{getMessstellenLookup(messstellenDict, row.messstelle, "umspannwerk")}</TableCell>
                            <TableCell>{getMessstellenLookup(messstellenDict, row.messstelle, "schaltfeld")}</TableCell>
                            <TableCell component="th" scope="row">{row.messstelle}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
